import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';

import externalConfiguration from './external-configuration';
import Visualizer from './visualizer/visualizer'

class App extends Component {
  render() {
    console.log( 'versionCode: ', externalConfiguration.versionData.versionCode);
    console.log( 'commitId: ', externalConfiguration.versionData.commitId);
    console.log( 'date: ', externalConfiguration.versionData.date);
    return (
      <BrowserRouter>
        <Route path='/:mode?/:id?/:id2?' component={Visualizer}/>
      </BrowserRouter>
    );
  }
}

ReactDOM.render( <App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js